// TotalInventory Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get totalInventoryList from backend then update totalInventoryList in vuex store ***** //
export const updateTotalInventoryList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get(`inventories_index/${payload.date}`, {
      params: params
    })
    commit('updateTotalInventoryList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Get reportInventoryList from backend then update reportInventoryList in vuex store ***** //
export const updateReportInventoryList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get(`report_inventories/${payload.outlet_id}/${payload.date}`, { params: params })
    commit('updateTotalInventoryList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch TotalInventory from backend ***** //
export const fetchTotalInventoryInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload.product_id)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`inventories_show/${payload.product_id}/${payload.date}`)
    commit('fetchTotalInventoryInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch inventory info from backend ***** //
export const fetchInventoryInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload.product_id)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`inventories_show_one/${payload.product_id}/${payload.date}`)
    commit('fetchInventoryInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}
